<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-verify-email',
    }"
  >
    <h1 class="page-title mt-6 mb-9">
      Check your inbox!
    </h1>
    <p class="p3 mb-6">
      You're almost in, {{ firstName }}! Just verify your email by
      following the link we've sent to {{ email }}.
    </p>
    <h2 class="text-h1 mb-4">
      Didn't receive it?
    </h2>
    <WizardFooter>
      <p class="text-h2 mb-6">
        Check your spam folder or<br> resend it
        by <a class="resend-anchor" @click="resendVerificationEmail">clicking here</a>.
      </p>
      <p class="text-h2">
        Having trouble?
        <a
          class="text-decoration-underline text-textBrand"
          :href="'mailto:hello@datapeople.io'
            + '?subject=Having%20issues%20verifying%20email%20on%20JobNav'"
        >
          Contact Us
        </a>
      </p>
    </WizardFooter>
  </WizardContent>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';
import { signupResendVerificationEmail } from '@/api/signup';
import WizardContent from '@/components/shared/WizardContent.vue';
import WizardFooter from '@/components/shared/WizardFooter.vue';

export default {
  name: 'VerifyEmail',
  components: {
    WizardContent,
    WizardFooter,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'email']),
  },
  created() {
    this.updateFlash({ status: 'success', message: 'Email sent! Please check and confirm.' });
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Verify Email' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash', 'resetFlash']),
    async resendVerificationEmail() {
      try {
        this.resetFlash();
        await signupResendVerificationEmail();
        this.updateFlash({ status: 'success', message: 'Verification email resent!' });
      } catch (e) {
        this.updateFlash({ message: 'Something went wrong' });
      }
    },
  },
};
</script>

<style scoped lang="less">
.page-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
}

.resend-anchor {
  color: @text-brand;

  &:hover {
    cursor: pointer;
  }
}
</style>
